import type { SortOrder } from 'cadenza/ui/base-table/sort-order';

export const SORT_CHANGE = 'change:sort';
export const PIVOT_SORT_CHANGE = 'change:pivotSort';

export interface DataTableSortEventDetails {
  columnName: string;
  columnHierarchyName?: string;
  order: SortOrder;
}

